import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from '../components/layout/layout.component';
import { MessagesListComponent } from './messages-list/messages-list.component';
import { CreateMessageComponent } from './create-message/create-message.component';
import { MessagesContainerComponent } from './messages-container/messages-container.component';

const routes: Routes = [
    {
        path: '', component: LayoutComponent,
        children: [
            {
                path: 'messages-list',
                component: MessagesContainerComponent
            },
            {
                path: 'create-messages',
                component: CreateMessageComponent
            },
            {
                path: '',
                redirectTo: '/messages/messages-list',
                pathMatch:'full'
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class MessagesRoutingModule { }